// File: src/pages/PrivacyPage.js
import React from 'react';
import { Layout, Typography, Card, Row, Col } from 'antd';
import { Helmet } from 'react-helmet-async';
import './PrivacyPage.css';

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const PrivacyPage = () => {
    return (
        <div className="privacy-page">
            <Helmet>
                {/* <title>Datenschutzerklärung | Snus Finder</title> */}
                <title>Datenschutz | Snus Verzeichnis Deutschland</title>
                {/* <meta name="description" content="Datenschutzerklärung von Snus Finder. Informationen darüber, wie wir Ihre persönlichen Daten schützen und verarbeiten." /> */}
                <meta name="description" content="Lesen Sie die Datenschutzbestimmungen von Snus Verzeichnis Deutschland." />
                <meta name="robots" content="noindex, follow" />
                <link rel="canonical" href="https://www.snus-finder.de/privacy" />
            </Helmet>

            <div className="privacy-header">
                <div className="container">
                    <h1>Datenschutzerklärung</h1>
                    <p className="last-updated">Letzte Aktualisierung: 01.03.2025</p>
                </div>
            </div>

            <div className="container">
                <div className="privacy-content">
                    <div className="privacy-toc">
                        <h2>Inhaltsverzeichnis</h2>
                        <ul>
                            <li><a href="#introduction">Einleitung</a></li>
                            <li><a href="#data-collected">Welche Daten wir erheben</a></li>
                            <li><a href="#data-usage">Wie wir Ihre Daten verwenden</a></li>
                            <li><a href="#data-sharing">Weitergabe von Daten</a></li>
                            <li><a href="#data-storage">Speicherung und Sicherheit</a></li>
                            <li><a href="#cookies">Cookies und Tracking</a></li>
                            <li><a href="#rights">Ihre Rechte</a></li>
                            <li><a href="#changes">Änderungen dieser Datenschutzerklärung</a></li>
                            <li><a href="#contact">Kontakt</a></li>
                        </ul>
                    </div>

                    <div className="privacy-sections">
                        <section id="introduction" className="privacy-section">
                            <h2>1. Einleitung</h2>
                            <p>
                                Willkommen bei Snus Finder. Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen.
                                In dieser Datenschutzerklärung informieren wir Sie darüber, welche Daten wir erheben, wie wir sie
                                verwenden und welche Rechte Sie haben.
                            </p>
                            <p>
                                Verantwortlich für die Datenverarbeitung auf dieser Website ist:
                            </p>
                            <div className="company-info">
                                <p>Heinz Consulting</p>
                                <p>Knollstraße 17</p>
                                <p>72072 Tübingen</p>
                                <p>Deutschland</p>
                                <p>E-Mail: info.snusfinder@gmail.com</p>
                                <p>Telefon: 01733958762</p>
                            </div>
                        </section>

                        <section id="data-collected" className="privacy-section">
                            <h2>2. Welche Daten wir erheben</h2>
                            <p>
                                Wir erheben verschiedene Arten von Informationen, darunter:
                            </p>

                            <h3>2.1 Von Nutzern</h3>
                            <ul>
                                <li>
                                    <strong>Automatisch erfasste Daten:</strong> Wenn Sie unsere Website besuchen, erfassen wir automatisch
                                    bestimmte Informationen, darunter IP-Adresse, Browsertyp, Betriebssystem, besuchte Seiten, Verweildauer und Zugriffsdatum/-zeit.
                                </li>
                                <li>
                                    <strong>Standortdaten:</strong> Wenn Sie die Funktion zur Suche nach Shops in Ihrer Nähe nutzen,
                                    fragen wir mit Ihrer Zustimmung Ihren Standort ab. Diese Daten werden nur temporär gespeichert und nicht
                                    mit Ihrem Profil verknüpft, sofern Sie nicht angemeldet sind.
                                </li>
                                <li>
                                    <strong>Suchanfragen:</strong> Wir speichern die von Ihnen eingegebenen Suchanfragen, um unseren Service zu verbessern.
                                </li>
                                <li>
                                    <strong>Kontaktformular:</strong> Wenn Sie unser Kontaktformular nutzen, erheben wir Ihren Namen, Ihre E-Mail-Adresse
                                    und den Inhalt Ihrer Nachricht.
                                </li>
                            </ul>

                            <h3>2.2 Von Shop-Betreibern</h3>
                            <ul>
                                <li>
                                    <strong>Registrierungsdaten:</strong> Bei der Registrierung eines Shops erheben wir geschäftsbezogene Daten
                                    wie Shopname, Adresse, Kontaktinformationen, Öffnungszeiten und angebotene Marken.
                                </li>
                                <li>
                                    <strong>Zahlungsinformationen:</strong> Für die Abwicklung von Zahlungen erheben wir notwendige Zahlungsdaten.
                                    Die eigentliche Zahlungsabwicklung erfolgt über unsere Zahlungsdienstleister, bei denen separate Datenschutzbestimmungen gelten.
                                </li>
                                <li>
                                    <strong>Shop-Bilder:</strong> Bilder, die Sie von Ihrem Shop hochladen, werden gespeichert und in unserem Verzeichnis angezeigt.
                                </li>
                            </ul>
                        </section>

                        <section id="data-usage" className="privacy-section">
                            <h2>3. Wie wir Ihre Daten verwenden</h2>
                            <p>
                                Wir verwenden Ihre Daten für folgende Zwecke:
                            </p>
                            <ul>
                                <li>Bereitstellung und Verbesserung unserer Dienste</li>
                                <li>Beantwortung Ihrer Anfragen und Kundenservice</li>
                                <li>Durchführung von Transaktionen und Verwaltung Ihres Kontos</li>
                                <li>Versenden von administrativen Mitteilungen und Updates zu unseren Diensten</li>
                                <li>Personalisierung Ihrer Erfahrung auf unserer Website</li>
                                <li>Analyse der Nutzung unserer Dienste zur Verbesserung des Angebots</li>
                                <li>Schutz unserer Dienste vor betrügerischen Aktivitäten</li>
                                <li>Einhaltung gesetzlicher Verpflichtungen</li>
                            </ul>

                            <h3>3.1 Rechtsgrundlage der Datenverarbeitung</h3>
                            <p>
                                Die Verarbeitung Ihrer personenbezogenen Daten erfolgt auf folgenden Rechtsgrundlagen:
                            </p>
                            <ul>
                                <li>Ihre Einwilligung gemäß Art. 6 Abs. 1 lit. a) DSGVO</li>
                                <li>Erfüllung eines Vertrags oder vorvertraglicher Maßnahmen gemäß Art. 6 Abs. 1 lit. b) DSGVO</li>
                                <li>Erfüllung rechtlicher Verpflichtungen gemäß Art. 6 Abs. 1 lit. c) DSGVO</li>
                                <li>Wahrung berechtigter Interessen gemäß Art. 6 Abs. 1 lit. f) DSGVO</li>
                            </ul>
                        </section>

                        <section id="data-sharing" className="privacy-section">
                            <h2>4. Weitergabe von Daten</h2>
                            <p>
                                Wir geben Ihre personenbezogenen Daten nur unter folgenden Umständen an Dritte weiter:
                            </p>
                            <ul>
                                <li>
                                    <strong>Dienstleister:</strong> Wir arbeiten mit Drittanbietern zusammen, die Dienstleistungen für uns erbringen,
                                    z.B. Website-Hosting, Datenanalyse, Zahlungsabwicklung und Kundenservice. Diese Dienstleister haben nur
                                    Zugriff auf die Daten, die sie zur Erfüllung ihrer Aufgaben benötigen.
                                </li>
                                <li>
                                    <strong>Shop-Daten:</strong> Die von Shop-Betreibern bereitgestellten öffentlichen Informationen
                                    (Name, Adresse, Öffnungszeiten, etc.) werden in unserem öffentlichen Verzeichnis angezeigt und sind für
                                    alle Nutzer der Website sichtbar.
                                </li>
                                <li>
                                    <strong>Gesetzliche Anforderungen:</strong> Wir können Ihre Daten offenlegen, wenn dies gesetzlich vorgeschrieben
                                    ist oder in Reaktion auf rechtmäßige Anfragen von Behörden.
                                </li>
                                <li>
                                    <strong>Geschäftsübergänge:</strong> Im Falle einer Fusion, Übernahme oder eines Verkaufs von Vermögenswerten
                                    können Ihre personenbezogenen Daten übertragen werden.
                                </li>
                            </ul>
                            <p>
                                Wir verkaufen Ihre personenbezogenen Daten nicht an Dritte.
                            </p>
                        </section>

                        <section id="data-storage" className="privacy-section">
                            <h2>5. Speicherung und Sicherheit</h2>
                            <h3>5.1 Speicherdauer</h3>
                            <p>
                                Wir speichern Ihre personenbezogenen Daten so lange, wie es für die Erfüllung der in dieser Datenschutzerklärung
                                beschriebenen Zwecke erforderlich ist, oder wie gesetzlich vorgeschrieben. Wenn Sie ein Konto bei uns haben,
                                bewahren wir Ihre Daten auf, solange Ihr Konto aktiv ist oder wie es zur Erbringung unserer Dienste für Sie erforderlich ist.
                            </p>

                            <h3>5.2 Datensicherheit</h3>
                            <p>
                                Wir setzen angemessene technische und organisatorische Maßnahmen ein, um Ihre personenbezogenen Daten vor
                                Verlust, Missbrauch und unbefugtem Zugriff zu schützen. Dazu gehören Verschlüsselung, Firewalls, regelmäßige
                                Sicherheitsüberprüfungen und Zugangsbeschränkungen für Mitarbeiter.
                            </p>

                            <h3>5.3 Datenübermittlung ins Ausland</h3>
                            <p>
                                Ihre Daten werden in der Europäischen Union gespeichert und verarbeitet. Sollte eine Übermittlung von Daten
                                an Dienstleister außerhalb der EU erforderlich sein, stellen wir sicher, dass ein angemessenes Datenschutzniveau
                                gemäß den Vorgaben der DSGVO gewährleistet ist.
                            </p>
                        </section>

                        <section id="cookies" className="privacy-section">
                            <h2>6. Cookies und Tracking</h2>
                            <p>
                                Unsere Website verwendet Cookies und ähnliche Technologien, um Ihre Erfahrung zu verbessern und Informationen
                                über die Nutzung unserer Services zu sammeln.
                            </p>

                            <h3>6.1 Was sind Cookies?</h3>
                            <p>
                                Cookies sind kleine Textdateien, die beim Besuch einer Website auf Ihrem Gerät gespeichert werden. Sie ermöglichen
                                es der Website, Sie bei einem erneuten Besuch wiederzuerkennen und Informationen über Ihre Aktivitäten zu speichern.
                            </p>

                            <h3>6.2 Arten von Cookies, die wir verwenden</h3>
                            <ul>
                                <li>
                                    <strong>Notwendige Cookies:</strong> Diese Cookies sind für den Betrieb unserer Website erforderlich und
                                    können nicht deaktiviert werden. Sie ermöglichen grundlegende Funktionen wie die Seitennavigation und den
                                    Zugriff auf sichere Bereiche der Website.
                                </li>
                                <li>
                                    <strong>Analyse-Cookies:</strong> Diese Cookies helfen uns zu verstehen, wie Besucher mit unserer Website
                                    interagieren, indem sie Informationen anonym sammeln und melden. Sie helfen uns, unsere Website zu verbessern.
                                </li>
                                <li>
                                    <strong>Funktionale Cookies:</strong> Diese Cookies ermöglichen erweiterte Funktionen und Personalisierung,
                                    wie z.B. Standortdatennutzung für lokale Suchanfragen.
                                </li>
                                <li>
                                    <strong>Werbe-Cookies:</strong> Diese Cookies können von unseren Werbepartnern über unsere Website gesetzt werden.
                                    Sie können von diesen Unternehmen verwendet werden, um ein Profil Ihrer Interessen zu erstellen und Ihnen
                                    relevante Anzeigen auf anderen Websites zu zeigen.
                                </li>
                            </ul>

                            <h3>6.3 Cookie-Verwaltung</h3>
                            <p>
                                Sie können Ihre Cookie-Einstellungen jederzeit über unser Cookie-Banner oder in den Einstellungen Ihres Browsers
                                ändern. Beachten Sie, dass das Blockieren oder Löschen bestimmter Cookies die Funktionalität unserer Website
                                beeinträchtigen kann.
                            </p>

                            <h3>6.4 Tracking-Tools</h3>
                            <p>
                                Wir verwenden folgende Analyse- und Tracking-Tools:
                            </p>
                            <ul>
                                <li>
                                    <strong>Google Analytics:</strong> Wir nutzen Google Analytics, um Informationen darüber zu sammeln, wie
                                    Besucher unsere Website nutzen. Google Analytics verwendet Cookies, um Informationen über Ihre Nutzung der
                                    Website zu sammeln. Diese Informationen werden verwendet, um Berichte zusammenzustellen und uns bei der
                                    Verbesserung der Website zu helfen. Die von Google Analytics gesetzten Cookies speichern keine personenbezogenen
                                    Informationen. Sie können die Erfassung durch Google Analytics verhindern, indem Sie das unter
                                    folgendem Link verfügbare Browser-Plugin herunterladen und installieren:
                                    <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">
                                        https://tools.google.com/dlpage/gaoptout
                                    </a>.
                                </li>
                            </ul>
                        </section>

                        <section id="rights" className="privacy-section">
                            <h2>7. Ihre Rechte</h2>
                            <p>
                                Als betroffene Person haben Sie bezüglich Ihrer personenbezogenen Daten gemäß DSGVO folgende Rechte:
                            </p>
                            <ul>
                                <li>
                                    <strong>Recht auf Auskunft (Art. 15 DSGVO):</strong> Sie haben das Recht zu erfahren, ob und welche
                                    personenbezogenen Daten wir über Sie verarbeiten.
                                </li>
                                <li>
                                    <strong>Recht auf Berichtigung (Art. 16 DSGVO):</strong> Sie können die Berichtigung unrichtiger oder
                                    unvollständiger Daten verlangen.
                                </li>
                                <li>
                                    <strong>Recht auf Löschung (Art. 17 DSGVO):</strong> Unter bestimmten Umständen haben Sie das Recht,
                                    die Löschung Ihrer Daten zu verlangen.
                                </li>
                                <li>
                                    <strong>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO):</strong> Sie können verlangen, dass
                                    die Verarbeitung Ihrer Daten eingeschränkt wird.
                                </li>
                                <li>
                                    <strong>Recht auf Datenübertragbarkeit (Art. 20 DSGVO):</strong> Sie haben das Recht, Ihre Daten in einem
                                    strukturierten, gängigen und maschinenlesbaren Format zu erhalten.
                                </li>
                                <li>
                                    <strong>Widerspruchsrecht (Art. 21 DSGVO):</strong> Sie haben das Recht, der Verarbeitung Ihrer Daten zu
                                    widersprechen, wenn diese auf Grundlage berechtigter Interessen erfolgt.
                                </li>
                                <li>
                                    <strong>Recht auf Widerruf einer Einwilligung (Art. 7 Abs. 3 DSGVO):</strong> Sie können eine erteilte
                                    Einwilligung jederzeit widerrufen, ohne dass die Rechtmäßigkeit der bis zum Widerruf erfolgten Verarbeitung berührt wird.
                                </li>
                                <li>
                                    <strong>Beschwerderecht bei einer Aufsichtsbehörde (Art. 77 DSGVO):</strong> Sie haben das Recht, sich bei einer
                                    Datenschutz-Aufsichtsbehörde zu beschweren, wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer Daten gegen
                                    die DSGVO verstößt.
                                </li>
                            </ul>
                            <p>
                                Um Ihre Rechte auszuüben, kontaktieren Sie uns bitte unter den im Abschnitt "Kontakt" angegebenen Kontaktdaten.
                            </p>
                        </section>

                        <section id="changes" className="privacy-section">
                            <h2>8. Änderungen dieser Datenschutzerklärung</h2>
                            <p>
                                Wir können diese Datenschutzerklärung von Zeit zu Zeit aktualisieren, um Änderungen unserer Praktiken oder aus anderen
                                betrieblichen, rechtlichen oder regulatorischen Gründen widerzuspiegeln. Die aktualisierte Version wird auf dieser Seite
                                veröffentlicht, und das Datum der "letzten Aktualisierung" wird entsprechend geändert.
                            </p>
                            <p>
                                Wir empfehlen Ihnen, diese Datenschutzerklärung regelmäßig zu überprüfen, um über den Schutz Ihrer Daten informiert zu bleiben.
                                Wesentliche Änderungen werden wir durch einen deutlichen Hinweis auf unserer Website oder per E-Mail ankündigen.
                            </p>
                        </section>

                        <section id="contact" className="privacy-section">
                            <h2>9. Kontakt</h2>
                            <p>
                                Wenn Sie Fragen oder Anliegen bezüglich dieser Datenschutzerklärung oder der Verarbeitung Ihrer personenbezogenen
                                Daten haben, kontaktieren Sie uns bitte:
                            </p>
                            <div className="contact-info">
                                <p>Heinz Consulting</p>
                                <p>Knollstraße 17</p>
                                <p>72072 Tübingen</p>
                                <p>Deutschland</p>
                                <p>E-Mail: info.snusfinder@gmail.com</p>
                                <p>Telefon: 01733958762</p>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPage;